"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenCapturePlugin = void 0;
var _elementSelectors = require("../constants/elementSelectors");
var _sentPostMessageTypes = require("../iframe-communication/constants/sentPostMessageTypes");
class ScreenCapturePlugin {
  constructor(widgetShell) {
    this.setWidgetVisibility = visible => {
      const parent = document.getElementById(_elementSelectors.PARENT_ID);
      if (parent) {
        parent.style.setProperty('opacity', visible ? '1' : '0');
      }
    };
    this.captureScreenshot = async () => {
      try {
        const stream = await navigator.mediaDevices.getDisplayMedia({
          // @ts-expect-error This is a non-spec property that forces the browser to capture the current tab
          // but it's only supported in Chrome for now so it's not typed.
          preferCurrentTab: true,
          video: {
            displaySurface: 'browser'
          }
        });
        const video = document.createElement('video');
        video.srcObject = stream;
        await video.play();
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        }
        stream.getTracks().forEach(track => track.stop());
        return canvas.toDataURL('image/png');
      } catch (e) {
        this.widgetShell.devLogger.error(e instanceof Error ? e.message : 'Unknown error');
      }
    };
    this.handleScreenCaptureRequest = async () => {
      this.setWidgetVisibility(false);
      const dataUrl = await this.captureScreenshot();
      if (dataUrl) {
        const fileName = `${document.title}-${Date.now()}.png`;
        this.widgetShell.iframeMessage.post(_sentPostMessageTypes.SCREEN_CAPTURE_BLOB, {
          dataUrl,
          fileName
        });
      }
      this.setWidgetVisibility(true);
    };
    this.widgetShell = widgetShell;
  }

  /**
   * Captures a screenshot of the current tab using the browser's mediaDevices API
   * @returns {Promise<string>} A promise that resolves to the dataUrl of the screenshot
   */
}
exports.ScreenCapturePlugin = ScreenCapturePlugin;